<template>
    <div class="ppv2-flex ppv2-flex-wrap ppv2-mb-8 ppv2-w-full" :style="{ gap: normalizeSize(16, true) }">
        <StatsCard
            v-for="item in navItems"
            :key="item.key"
            class="ppv2-flex-1 md:ppv2-min-w-[200px] md:ppv2-max-w-[240px]"
            :isActive="activeTab === item.key"
            :count="stats[item.countKey] || 0"
            :label="item.label"
            :icon="item.icon"
            @click="$emit('click', item.key)"
        />
    </div>
</template>

<script>
import normalizeSize from '../../../utils/normalizeSize'

import StatsCard from '../Food/StatsCard.vue'
import { Tag, FolderTree, Package, List } from 'lucide-vue'

export default {
    name: 'ExperienceStatsNavigation',
    components: {
        StatsCard,
    },
    props: {
        activeTab: {
            type: String,
            required: true,
        },
        stats: {
            type: Object,
            required: true,
            default: () => ({
                experiences: 0,
            }),
        },
        canConsultExperience: {
            type: [Boolean, String],
            default: true,
        },
        canConsultCategories: {
            type: [Boolean, String],
            default: true,
        },
        canConsultForfait: {
            type: [Boolean, String],
            default: true,
        },
        canConsultFormule: {
            type: [Boolean, String],
            default: true,
        },
        canConsultAbonnement: {
            type: [Boolean, String],
            default: true,
        },
    },
    computed: {
        navItems() {
            const items = []

            if (
                String(this.canConsultExperience) !== 'false' ||
                String(this.canConsultForfait) !== 'false' ||
                String(this.canConsultFormule) !== 'false' ||
                String(this.canConsultAbonnement) !== 'false'
            ) {
                items.push({
                    key: 'experiences',
                    countKey: 'experiences',
                    label: this.$t('experiences.navigation.experiences'),
                    icon: Tag,
                })
            }

            if (String(this.canConsultCategories) !== 'false') {
                items.push({
                    key: 'categories',
                    countKey: 'categories',
                    label: this.$t('experiences.navigation.categories'),
                    icon: Tag,
                })
            }

            return items
        },
    },
    methods: {
        normalizeSize,
    },
}
</script>
